import React from 'react';
import { ReactComponent as LockIcon } from 'style/icons/large-red-lock.svg';
import Text from 'components/Text';
import { Button } from 'components/form/Button';

const TwoFADisabled = props => {
  return (
    <div style={{ maxWidth: 430 }}>
      <div className="text-16 bold fontRed200 padB8">
        <LockIcon /> Authentication disabled
      </div>
      <Text className="padTB8">
        We’ll send you a security code if we notice an attempted login from an
        unrecognized device, or if you change your phone number, email address,
        or password.
      </Text>
      <Text className="padTB8">
        Make sure your phone number and email are correct. Contact support if
        you are having trouble changing your phone number or email.
      </Text>
      <div className="text-right">
        <Button
          datatestid="twofactor-profile-cancel"
          onClick={props.toggleTwoFactorExpansion}
          mrphType="standardThick"
          className="m-margTB8 margTB0 margR8 m-margr0"
        >
          Cancel
        </Button>
        <Button
          datatestid="twofactor-profile-enable"
          onClick={props.enableTwoFactorAuthentication}
          mrphType="primary"
        >
          Enable
        </Button>
      </div>
    </div>
  );
};

export default TwoFADisabled;
